export const LOAD_ROLLS_IN = 'LOAD_ROLLS_IN';
export const SET_ROLLS_IN_FILTER = 'SET_ROLLS_IN_FILTER';
export const SET_ROLLS_IN_PAGINATION = 'SET_ROLLS_IN_PAGINATION';
export const SET_ROLLS_IN_SORT = 'SET_ROLLS_IN_SORT';
export const RESET_ROLLS_IN_FILTERS = 'RESET_ROLLS_IN_FILTERS';
export const CHANGE_ROLL_IN_SRTATUS = 'CHANGE_ROLL_IN_SRTATUS';
